import React from 'react';

import './downloadSection.css';

import appImg from '../../assets/images/app.png';
import { Container, Row, Col } from 'reactstrap';

const DownloadSection = () => {
    return (
        <section>
            <Container className="app__container">
                <Row className="align-items-center">
                    <Col lg="6" md="6">
                        <div className="app__img  ">
                            <img src={appImg} alt="download our mobile app" className="w-100" />
                        </div>
                    </Col>

                    <Col lg="6" md="6">
                        <div className="app__content">
                            <h5>Download our app</h5>
                            <h2 className="mb-4">
                                Never feel hungry! Downlaod Our Mobile App Order Delicious Food
                            </h2>
                            <p>
                                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Velit
                                reprehenderit repellat dicta natus excepturi ex vitae fuga commodi
                                placeat soluta!
                                <span className="app__btns d-flex align-items-center gap-5 mt-5">
                                    <button className="btn__apple d-flex  align-items-center gap-3">
                                        <i className="ri-apple-line"></i>
                                        <a href="#">Apple Store</a>
                                    </button>

                                    <button className="btn__google d-flex  align-items-center gap-3">
                                        <i className="ri-google-play-line"></i>
                                        <a href="#">Google Play</a>
                                    </button>
                                </span>
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default DownloadSection;
